import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ShHtmlParserComponent } from '../core/html-parser/html-parser.component';

import { ShIconModule } from '../elements/components/icon/icon.module';

import { ShBooleanDialogComponent } from './components/boolean-dialog/boolean-dialog.component';
import { ShDynamicDialogComponent } from './components/dynamic-dialog/dynamic-dialog.component';
import { DialogInsertionDirective } from './directives/dynamic-dialog-insertion.directive';
import { ShDynamicDialogService } from './services/dynamic-dialog.service';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ShIconModule,
        ShHtmlParserComponent,
        ShDynamicDialogComponent,
        DialogInsertionDirective,
        ShBooleanDialogComponent
    ],
    exports: [ShDynamicDialogComponent, DialogInsertionDirective, ShBooleanDialogComponent],
    providers: [ShDynamicDialogService]
})
export class ShDynamicDialogModule {}

export { ShBooleanDialogComponent } from './components/boolean-dialog/boolean-dialog.component';
export { ShDynamicDialogComponent } from './components/dynamic-dialog/dynamic-dialog.component';
export { ShTextInputDialogComponent } from './components/text-input-dialog/text-input-dialog.component';
export { DialogInsertionDirective } from './directives/dynamic-dialog-insertion.directive';
